"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));
var _vbiClientCollector = _interopRequireDefault(require("vbi-client-collector"));
require("videojs-overlay");
require("video.js/dist/video-js.css");
require("./vjs.css");
var _defaultConfig = require("./config/defaultConfig");
var _StandardVideoPlayer = _interopRequireDefault(require("./StandardVideoPlayer"));
var _HiveVideoPlayer = _interopRequireDefault(require("./HiveVideoPlayer"));
var _RampVideoPlayer = _interopRequireDefault(require("./RampVideoPlayer"));
var _MicrosoftECDNVideoPlayer = _interopRequireDefault(require("./MicrosoftECDNVideoPlayer"));
var _DebugManager = _interopRequireDefault(require("../utils/DebugManager"));
var _RUMUtil = _interopRequireDefault(require("../utils/RUMUtil"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Players
var dmInstance = _DebugManager["default"].dmInstance;
var VideoManager = exports["default"] = /*#__PURE__*/function () {
  function VideoManager(dataHandler, errorHandler, playingHandler) {
    var _this = this;
    _classCallCheck(this, VideoManager);
    _defineProperty(this, "setupTextTracks", function () {
      var vttFiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      // first clear out existing tracks
      var tracks = _this.videoPlayer.textTracks();
      var i = tracks.length;
      while (i--) {
        _this.videoPlayer.removeRemoteTextTrack(tracks[i]);
      }
      vttFiles.forEach(function (item) {
        if (item.url) {
          var opts = {
            kind: 'captions',
            label: item.name,
            src: item.url
          };
          _this.videoPlayer && _this.videoPlayer.addRemoteTextTrack(opts, true);
        }
      });
      return true;
    });
    _defineProperty(this, "setupOverlay", function (player) {
      var sentimentObject = document.getElementById('sentimentWidget');
      player.overlay({
        debug: false,
        overlays: [{
          content: sentimentObject,
          start: 'playing',
          end: 'ended'
        }]
      });
    });
    _defineProperty(this, "initiateEventListeners", function () {
      var isPreview = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var userId = arguments.length > 1 ? arguments[1] : undefined;
      var seekTo = arguments.length > 2 ? arguments[2] : undefined;
      if (seekTo) {
        _this.videoPlayer.ready(function () {
          _this.videoPlayer.currentTime(seekTo);
        });
      } else {
        _this.videoPlayer.ready(function () {
          _this.videoPlayer.currentTime(0);
        });
      }
      /*
        Event processing will change from polling to inband
        when the `playingHandler` is called. We wanting to maintain
        polling during preview because events are not sent inband
        when the event has not yet started.
        WN-3598
      */
      if (!isPreview) {
        _this.videoPlayer.on('playing', _this.playingHandler);
      }

      // this is one way to capture the text track selection
      // for now we will submit to datadog
      // we want to exlude CaptionSettingsMenuItem as this is
      // the CC settings dialog overlay
      // WN-6397
      var subtitleMap = {};
      _this.videoPlayer.textTracks().addEventListener('addtrack', function (event) {
        _this.videoPlayer.controlBar.subsCapsButton.items.forEach(function (menuItem) {
          if (menuItem.name() !== 'CaptionSettingsMenuItem') {
            var menuEl = menuItem.contentEl();
            menuEl.addEventListener('click', function () {
              var menuText = menuItem.el().textContent.toLowerCase().replace(', selected', '').replace(' captions', '').trim();
              if (menuText === 'captions off') {
                _RUMUtil["default"].addAction("Closed Caption turned off by user ".concat(userId));
              } else {
                _RUMUtil["default"].addAction("Closed Caption selected '".concat(menuText, "' by user ").concat(userId));
              }
            });
          }
        });
        var track = event.track,
          _event$track = event.track,
          _event$track2 = _event$track === void 0 ? {} : _event$track,
          kind = _event$track2.kind,
          id = _event$track2.id,
          activeCues = _event$track2.activeCues;
        if (kind === 'subtitles') {
          subtitleMap[id] = id;
        }

        // Ensure that the captions are positioned at the bottom of player.
        // WN-6692
        if (kind === 'captions') {
          track.addEventListener('cuechange', function () {
            Array.from(activeCues).map(function (cue) {
              switch (cue.line) {
                case 1:
                  cue.line = 13;
                  break;
                case 2:
                  cue.line = 14;
                  break;
                case 3:
                  cue.line = 15;
                  break;
                case 4:
                  cue.line = 16;
                  break;
                default:
                  break;
              }
            });
          });
          // if the subtitle track with id 'cc' exists, we need to remove the closed caption
          // track.. in this case, there will be no closed caption available in the player
          // even though the UI allows the producer to select 5 closed caption languages..
          // there must be a better way..
          // note: in all of my testing, the closed caption track appeared later than all
          // subtitle tracks so this assumes the subtitles have been detected already..
          if (subtitleMap['cc']) {
            _this.videoPlayer.removeRemoteTextTrack(track);
          }
        }
      });
      _this.videoPlayer.on('loadedmetadata', function () {
        var tracks = _this.videoPlayer.textTracks();
        for (var i = 0; i < tracks.length; i++) {
          var track = tracks[i];
          var _track$id = track.id,
            id = _track$id === void 0 ? '' : _track$id,
            _track$kind = track.kind,
            kind = _track$kind === void 0 ? '' : _track$kind;
          if (kind.toLowerCase() === 'subtitles') {
            if (id.toLowerCase() === 'cc') {
              track.label = 'Live Captions';
            }
            if (id.toLowerCase() === 'zh-tw') {
              track.label = '中文（繁體)';
            }
            if (id.toLowerCase() === 'fr-ca') {
              track.label = 'français (canada)';
            }
            if (id.toLowerCase() === 'pt-pt') {
              track.label = 'português (portugal)';
            }
            if (id.toLowerCase() === 'es-mx') {
              track.label = 'español (mexico)';
            }
          }
        }
      });

      // the following is to address a bug in videojs where cuechange event
      // not fired.. see WN-6847 for more info
      // we're going to add a half second if start and end time are the same
      // this will ensure the cue becomes active
      _this.videoPlayer.textTracks().addEventListener('addtrack', function (event) {
        var _event$track3 = event.track,
          label = _event$track3.label,
          cues = _event$track3.cues,
          track = event.track;
        if (label === "Timed Metadata") {
          var timer = setInterval(function () {
            for (var i = 0; i < cues.length; i++) {
              var cue = cues[i];
              if (cue.startTime === cue.endTime) {
                cue.endTime += .5;
              }
            }
          }, 1000);
        }
      });
    });
    this.dataHandler = dataHandler || this.missingHandler;
    this.errorHandler = errorHandler || this.missingHandler;
    this.playingHandler = playingHandler || this.missingHandler;
  }
  return _createClass(VideoManager, [{
    key: "missingHandler",
    value: function missingHandler() {
      throw new Error('Missing handler function!');
    }
  }, {
    key: "constructPlayer",
    value: function constructPlayer(videoId, videoConfig, urls, vbiConfig, eventId, vbiAccountId, userId, type, isPreview, presentationType, authParams) {
      var _this2 = this;
      // initialize the player with <video> id and configuration values:
      // all video players return a promise
      var videoPlayer;
      var videoPlayerPromise;

      // Retrieve a video config.
      // The configuration generator will ensure that the correct html5/hls options
      // and correct plugins are loaded based on the current device/browser.
      var config = (0, _defaultConfig.getPlayerConfig)(urls, this.errorHandler, this.dataHandler, type, videoConfig, presentationType);
      var extendedConfig = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, config), videoConfig), {
        params: authParams
      }), {}, {
        userId: userId,
        eventId: eventId,
        urls: urls,
        presentationType: presentationType
      });
      dmInstance.logMessage([_DebugManager["default"].debugLevel.M], '[VideoManager] player configuration: ', extendedConfig);
      if (videoConfig.hiveEnabled) {
        videoPlayer = _HiveVideoPlayer["default"];
      } else if (videoConfig.microsoftEnabled) {
        videoPlayer = _MicrosoftECDNVideoPlayer["default"];
      } else if (videoConfig.rampEnabled) {
        extendedConfig.fallbackUrls = urls;
        // this can be overridden using mAddr query param
        extendedConfig.mAddr = '239.0.0.1:12345';
        videoPlayer = _RampVideoPlayer["default"];
      } else {
        videoPlayer = _StandardVideoPlayer["default"];
      }
      videoPlayerPromise = videoPlayer(videoId, extendedConfig);
      videoPlayerPromise.then(function (player) {
        if (!player) return null;
        _this2.videoPlayer = player;
        _this2.initiateEventListeners(isPreview, userId, extendedConfig.seekTo);
        if (!isPreview) {
          _this2.initiateVBI(vbiConfig, eventId, vbiAccountId, userId, presentationType, extendedConfig.ipAddress);
        }
        _this2.setupTextTracks(extendedConfig.vttFileList);
        _this2.setupOverlay(player);
      })["catch"](function (error) {
        console.error("[VideoManager] constructPlayer() Error inititating video player:".concat(error));
      });
      return {
        promise: videoPlayerPromise,
        player: videoPlayer
      };
    }
  }, {
    key: "destroyPlayer",
    value: function destroyPlayer() {
      this.videoPlayer && this.videoPlayer.dispose();
    }
  }, {
    key: "initiateVBI",
    value: function initiateVBI(conf, eventId, vbiAccountId, userId, presentationType, ipAddress) {
      // If no account config passed in then forget it
      if ((0, _isUndefined["default"])(conf) || (0, _isEmpty["default"])(conf)) return;
      var vbi = new _vbiClientCollector["default"](conf);
      vbi.registerObject(this.videoPlayer, {
        type: 'videojs',
        eventId: eventId,
        accountId: vbiAccountId,
        userId: userId,
        eventType: presentationType,
        ipAddress: ipAddress
      });
    }
  }]);
}();